import UltimateDiscover from './UltimateDiscover';

export default function UltimateDiscoverPage() {
  return <UltimateDiscover />;
}